import React from "react";
import withNav from "../hoc/with-nav";
import SingleOrder from "./single-order";

function SingleOrderPage() {
  return <SingleOrder />;
}

export default withNav(SingleOrderPage, false, false);
